import { DatePicker, DefaultButton, Dropdown, IDropdownOption, IDropdownStyles, IconButton, Panel, PanelType, PrimaryButton, Spinner, Stack } from "office-ui-fabric-react";
import { useEffect } from "react";
import { useState } from "react";
import { Line } from "react-chartjs-2";
import { getTagsByType } from "../../../api/tagging";
import { TagType } from "../../../types/Tagging.types";

export interface IReportingProps {
    onDismiss: () => void;
}

const tagDropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 200 } };

const defaultStartDate = new Date();
defaultStartDate.setDate(1);
defaultStartDate.setHours(0);
defaultStartDate.setMinutes(0);
defaultStartDate.setSeconds(0);
defaultStartDate.setMilliseconds(0);
const defaultEndDate = new Date(defaultStartDate.getTime());
defaultEndDate.setMonth(defaultStartDate.getMonth() + 1);
defaultEndDate.setDate(defaultEndDate.getDate() - 1);

export const Reporting = (props: IReportingProps) => {

    const [ startDate, setStartDate ] = useState<Date>(defaultStartDate);
    const [ endDate, setEndDate ] = useState(defaultEndDate);
    const [ filterType, setFilterType ] = useState<string>("all");
    const [ chartTitle, setChartTitle ] = useState<string>("All Desk and Room Bookings");
    const [ tagOptions, setTagOptions ] = useState<IDropdownOption[]>([]);
    const [ selectedTag, setSelectedTag ] = useState<number|null>();
    const [ loading, setLoading ] = useState(false);
    
    const [ chartData, setChartData ] = useState<any>();

    const _load = async () => {
        const tagResponse = await getTagsByType(TagType.User);
        if (tagResponse.length) {
            const tagOptions:IDropdownOption[] = tagResponse.map((s) => {
                return {
                    key: s.Id,
                    text: s.Label
                }
            });
            setTagOptions(tagOptions);
        }
    }    

    const _loadCountStats = async () => {
        setLoading(true);
        if (startDate && endDate) {
            let url = '';
            if (filterType == "tag" && selectedTag) {
                url = `/api/bookings/stats/filter/${filterType}/${selectedTag}/from/${encodeURIComponent(startDate.toISOString())}/to/${encodeURIComponent(endDate.toISOString())}`;
            } else {
                url = `/api/bookings/stats/filter/${filterType}/0/from/${encodeURIComponent(startDate.toISOString())}/to/${encodeURIComponent(endDate.toISOString())}`;
            }

            const response = await fetch(url);
            if (response.ok) {
                const bookingCounts = await response.json() as Record<string,number>;
                const labels = Object.keys(bookingCounts);
                const counts = Object.entries(bookingCounts).map((e) => e[1]);
                const cData = {
                    labels,
                    datasets: [
                        {
                            label: '# of bookings',
                            data: counts,
                            fill: false,
                            backgroundColor: 'rgb(255, 99, 132)',
                            borderColor: 'rgba(255, 99, 132, 0.2)',
                        }
                    ]
                };
                setChartData(cData);
                setLoading(false);
            } else {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        _load();
        _loadCountStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        _loadCountStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate, filterType, selectedTag]);

    return (
        <Panel type={PanelType.custom} customWidth="900px" headerText="Reporting" isOpen={true} onDismiss={props.onDismiss}>
            <p>Select a date range below to see a booking count for the period, use the export button to export booking data for the period as a .CSV file.</p>
            <DatePicker label="Start" value={startDate} onSelectDate={(date) => { if (date) setStartDate(date) }} />
            <DatePicker label="End" value={endDate} onSelectDate={(date) => { if (date) setEndDate(date) }} />
            <div style={{display:"flex",alignItems:"center",marginTop:20,marginBottom:20}}>
                <div style={{marginRight:10}}>Filters:</div>
                <DefaultButton style={{marginRight:10}} text="All Bookings" iconProps={{iconName:'BulletedListText'}} onClick={() => {
                    setFilterType("all")
                    setChartTitle("All Desk and Room Bookings")
                    setSelectedTag(null);
                }} />
                <DefaultButton style={{marginRight:10}} text="Desks" iconProps={{iconName:'PC1'}} onClick={() => {
                    setFilterType("desk")
                    setChartTitle("All Desk Bookings")
                    setSelectedTag(null);
                }} />
                <DefaultButton style={{marginRight:10}} text="Rooms" iconProps={{iconName:'Room'}} onClick={() => {
                    setFilterType("room")
                    setChartTitle("All Room Bookings")
                    setSelectedTag(null);
                }} />
                <Dropdown style={{marginRight:10}} styles={tagDropdownStyles} selectedKey={selectedTag} placeholder="Select a user tag" options={tagOptions} onChange={(event, option, index) => { 
                    if (option) {
                        setFilterType("tag")
                        setChartTitle("All Bookings by " + option.text)
                        setSelectedTag(option.key as number)
                    }
                }} /> 
            </div>
            { loading === true && (
                <Spinner />
            )}
            <h2 style={{textAlign:"center"}}>{chartTitle}</h2>
            { loading === false && Boolean(chartData) === true && (
                <Line data={chartData} />
            )}
            <Stack horizontal horizontalAlign="end" style={{marginTop: 20}}>
                <PrimaryButton text="Export" iconProps={{iconName: "Export"}} href={`/api/bookings/export/filter/${filterType}/${selectedTag == null ? 0 : selectedTag}/from/${encodeURIComponent(startDate.toISOString())}/to/${encodeURIComponent(endDate.toISOString())}`} target="_blank" />
                <DefaultButton text="Close" iconProps={{iconName: "Cancel"}} onClick={props.onDismiss} style={{marginLeft: 10}}/>
            </Stack>
        </Panel>
    );
}